import { GameManager } from "../../GameManager";
import { GameVars } from "../../GameVars";

export class DevLevelButton extends Phaser.GameObjects.Container {

    private level: number;
    private IDmapType: number;

    constructor(scene: Phaser.Scene, level: number, mapType: number) {

        super(scene);

        this.IDmapType = mapType;

        this.level = level;

        this.setScale(.75);

        const btn = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "gem_02_on");
        btn.setOrigin(.5);
        btn.setInteractive();
        btn.on("pointerover", function (): void {
            btn.setTexture("texture_atlas_1", "gem_02_light");
        }, this);
        btn.on("pointerout", function (): void {
            btn.setTexture("texture_atlas_1", "gem_02_on");
        }, this);
        btn.on("pointerdown", this.onClick, this);
        this.add(btn);

        const levelLabel = new Phaser.GameObjects.Text(this.scene, 0, 0, this.level.toString(), { fontFamily: "Oswald-DemiBold", fontSize: "20px", color: "#f0faf9"});
        levelLabel.setOrigin(.5);
        levelLabel.setShadow(2, 2, "#38536f", .5);
        this.add(levelLabel);
    }

    private onClick(): void {

        const levelID = this.IDmapType * 1000 + this.level;
        GameManager.enterBoardScene();  
    }
}

